<template>
  <div>
    <truck-map></truck-map>
    <gps-feeds></gps-feeds>
    <fleets></fleets>
    <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white t-mb-5">
      <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4 t-mb-3">
        <h3 class="t-text-xl t-font-bold">
          Vehicles
        </h3>
      </div>

      <vehicles-table @clicked="onClickChild"></vehicles-table>
      <vehicle-form v-if="modal"></vehicle-form>
    </section>
  </div>
</template>

<script>
import Fleets from "../../../components/carrier/trucks/Fleets";
import GpsFeeds from "../../../components/carrier/trucks/GpsFeeds";
import TrucksTable from "../../../components/carrier/trucks/TrucksTable";
import VehiclesTable from "../../../components/tables/VehiclesCarrier";
import VehicleForm from "../../../components/form/VehicleCarrier";
import TruckMap from "../dashboard/TruckMap";

export default {
  name: "Trucks",
  components: {
    Fleets,
    GpsFeeds,
    TrucksTable,
    VehiclesTable,
    VehicleForm,
    TruckMap,
  },
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    onClickChild(value) {
      this.modal = value;
    },
  },
};
</script>

<style scoped>
</style>